<template>
    <div class="myPagination">
        <el-pagination size="medium" background :page-size="limit" layout="prev, pager, next" :total="allNum"
            @current-change="goPagin">
        </el-pagination>
    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        allNum: {
            type: Number,
            default: 12,
        },
        limit: {
            type: Number,
            default: 6,
        }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        goPagin(data) {
            this.$emit('current-change', data)
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .el-pagination {
    display: flex;
}

::v-deep .el-pager .number {
    width: 30px !important;
    height: 30px !important;
    background: #ffffff !important;
    line-height: 30px;
    min-width: 0;
    color: #7F7F7F;
    font-weight: 400;
    font-size: 18px;
}

::v-deep .el-pager .active {
    color: #000000 !important;
    font-weight: bold;
}

::v-deep .el-pagination.is-background .btn-prev {
    height: 30px !important;
    border-radius: 50%;
    background: #7F7F7F;
    border: 1px solid #7F7F7F;
    color: #ffffff;
}

::v-deep .el-pagination.is-background .btn-next {
    height: 30px !important;
    border-radius: 50%;
    background: #7F7F7F;
    border: 1px solid #7F7F7F;
    color: #ffffff;
}

::v-deep .el-pagination button:disabled {
    border: 1px solid #010101;
    background: #FFFFFF !important;
    color: #010101 !important;
    border-radius: 50%;
    height: 30px;
}
</style>